// extracted by mini-css-extract-plugin
export var root = "F_wb";
export var wrapper = "F_wc";
export var image = "F_wd d_w d_y d_W";
export var imageWithHeight = "F_wf";
export var crop = "F_wg";
export var round = "F_wh";
export var fixedHeight = "F_wj";